import styled from 'styled-components';

// classe de overwride do react-image-crop
export const UploaderStyled = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;

  .ReactCrop {
    max-height: calc(100vh - 200px);
    margin: 0 auto;
    ${(props) => props?.width && `width:${props?.width}px;`}
  }

  img {
    max-height: calc(100vh - 200px);
  }
`;

export const ButtonsFotter = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding-top: 8px;
`;
